import { Injectable, OnInit } from "@angular/core";
import { SpinnerService } from "../spinner/spinner.service";
import { Web3Service } from "../web3/web3.service";
import { eStatus, iStatus } from "../web3/web3.config";

@Injectable({
    providedIn: 'root'
})

export class WalletInterceptor {
    constructor(
        private spinnerService: SpinnerService,
        private web3Service: Web3Service
    ) { }

    load() {
        this.web3Service.signStatus$.subscribe((s: Map<string, iStatus>) => {
            //at least 1 in status pending
            if (Array.from(s.values()).some(s => s.status === eStatus.pending)) this.spinnerService.setSpinner(true)
            else this.spinnerService.setSpinner(false)
        })
    }
}